export const DeliverySettings = {
  Normal: 'normal',
  SendToOne: 'send_to_one',
  Off: 'off',
} as const;
export type DeliverySettings = (typeof DeliverySettings)[keyof typeof DeliverySettings];

export interface MergedWorkspace {
  id: number;
  account_id: number;
  cio_workspace_id: number;
  cdp_workspace_id: number;
  cio_initialized: boolean;
  cdp_initialized: boolean;
  name: string;
  color: string;
  delivery_settings: DeliverySettings;
  delivery_email: string;
}

export interface WorkspaceObjectType {
  id: number;
  name: string;
  slug: string;
  colour: string;
  icon: string;
}

export interface SampleAccountsApi {
  accounts: SampleAccountApi[];
}

export interface SampleAccountApi {
  environment_ids: number[];
  id: number;
}
